import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Toaster } from '../components/ui/sonner';
import { toast } from 'sonner';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Welcome back!');
      navigate('/admin/dashboard');
    } catch (error) {
      const detail = error.response?.data?.detail;
      const message = typeof detail === 'string' ? detail : 
        Array.isArray(detail) ? detail.map(e => e.msg).join(' ') : 
        'Login failed';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF7F2] flex items-center justify-center px-6">
      <Toaster position="top-center" richColors />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <div className="text-center mb-8">
          <h1 
            className="text-4xl font-light text-[#2B2623] mb-2"
            style={{ fontFamily: 'Cormorant Garamond, serif' }}
          >
            BraidsbyAbbee
          </h1>
          <p className="text-[#756A63]">Admin Dashboard Login</p>
        </div>

        <div className="bg-white/60 backdrop-blur-md rounded-3xl p-8 border border-white/20 shadow-lg">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="text-sm font-medium text-[#2B2623] mb-2 block">Email</label>
              <Input
                data-testid="login-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@email.com"
                required
                className="h-12 rounded-xl border-[#E3DACD] bg-white/50 focus-visible:ring-[#9C6A48]"
              />
            </div>
            <div>
              <label className="text-sm font-medium text-[#2B2623] mb-2 block">Password</label>
              <Input
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                className="h-12 rounded-xl border-[#E3DACD] bg-white/50 focus-visible:ring-[#9C6A48]"
              />
            </div>
            <Button
              data-testid="login-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full rounded-full bg-[#9C6A48] hover:bg-[#8B5A33] text-white py-6 text-base"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </form>
        </div>

        <p className="text-center text-sm text-[#756A63] mt-6">
          <a href="/" className="hover:text-[#9C6A48] transition-colors">
            ← Back to website
          </a>
        </p>
      </motion.div>
    </div>
  );
}
